import { fontSize as fontSize_1 } from './fontSize.locstring.json';
import loc from 'owa-localize';
import { callFormatApi } from 'owa-editor/lib/utils/callFormatApi';
import PickerInputButtonBase from '../PickerInputButtonBase';
import { getFontSizeFromSizeOrIndex } from 'owa-format-options';
import { getStore } from 'owa-editor-ribbon-secondary-ui/lib/store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const DEFAULT_FONT_SIZE = 3;

export default class FontSizeWithInput extends PickerInputButtonBase {
    constructor() {
        super(
            'fontSize',
            loc(fontSize_1),
            getStore().fontSize,
            40 /*inputWidth*/,
            4 /*maxLength*/,
            false /*autoComplete*/
        );
    }

    updatePickerItems = () => {};

    onChange = (value: string) => {
        callFormatApi(this.editorViewState, 'setFontSize', [value + 'pt']);
    };

    normalizeValue = (value: string) => {
        let intValue = parseInt(value);
        return Math.max(Math.min(intValue, 1000), 8).toString();
    };

    getCurrentValue = () => {
        return this.formatViewState.fontSize || getDefaultFontSize();
    };
}

function getDefaultFontSize() {
    const userOption = getUserConfiguration().UserOptions;
    const size = userOption?.ComposeFontSize || DEFAULT_FONT_SIZE;
    return getFontSizeFromSizeOrIndex(size).toString();
}
